<template>
    <div class="page-bg login" v-if="!isLoading">
        <v-container fill-height justify-center>
            <div class="login-block" v-if="!instituteError">
                <div class="Client-logo">
                    <img :src="logo" class="Client-logo-img" />
                </div>
                <template v-if="dialog">
                    <div class="text-center">
                        <v-dialog
                            v-model="dialog"
                            width="530"
                            class="modal-size"
                            persistent="true"
                        >
                            <v-card>
                                <div class="Client-logo modal-logo">
                                    <img :src="logo" class="Client-logo-img" />
                                </div>
                                <v-card-text class="link-area">
                                    <div class="msg-text">
                                        We are happy to inform you that we have
                                        moved to a more stable platform.
                                    </div>
                                    <a
                                        class="msg-text3"
                                        href="https://mseducation.eduracle.com"
                                        >https://mseducation.eduracle.com</a
                                    >
                                    <div>
                                        You can now access this portal using
                                        above link with same login credentials
                                        that you had in the previous portal.
                                    </div>
                                </v-card-text>
                                <div class="msg-text2">
                                    <img
                                        :src="footerLogo"
                                        class="master-logo"
                                    />
                                </div>
                            </v-card>
                        </v-dialog>
                    </div>
                </template>
                <v-form v-else class="login-frm">
                    <v-row>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <v-text-field
                                @keyup.enter="submit"
                                autocomplete="new-password"
                                v-model="userId"
                                label="Email ID"
                                dense
                                outlined
                                hide-details
                                ref="userId"
                            ></v-text-field>
                            <InputError :data="error.email" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero icon-input">
                            <v-text-field
                                @keyup.enter="submit"
                                autocomplete="new-password"
                                v-model="password"
                                label="Password"
                                dense
                                outlined
                                hide-details
                                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show1 ? 'text' : 'password'"
                                @click:append="show1 = !show1"
                            ></v-text-field>
                            <InputError :data="error.password" />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="forgot-pass">
                                <span
                                    v-if="!onlineInstitute"
                                    class="forgot-pass-label"
                                    @click="onForgotPassword"
                                    >Forgot Password?</span
                                >
                            </div>
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="signup-primary">
                                <div class="user-new-signup">
                                    <span v-if="showSignup" class="new-user">New user?</span>
                                    <span v-if="showSignup" @click="signUp" class="signup-user"
                                        >Sign Up!</span
                                    >
                                </div>
                                <div class="sign-up-btn">
                                    <v-btn
                                        @click="submit"
                                        class="right-btn cust-btn"
                                        color="primary"
                                        >Log In</v-btn
                                    >
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
                    <img
                        :src="footerLogo"
                        class="master-logo"
                    />
                </div>
            </div>
            <div class="institute" v-else>
                {{ instituteError }}
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import menuList from "@/utils/menu";
import Vue from "vue";  
import VueCookies from 'vue-cookies';
import constants from "@/utils/constants.js";
Vue.use(VueCookies)

export default {
    name: "login",

    data: () => ({
        show1: false,
        userId: "",
        password: "",
        dialog: false,
        logo: null,
        menus: [],
        error: {
            email: {
                type: null,
                message: null,
            },
            password: {
                type: null,
                message: null,
            },
        },
        keepMeLoggedIn:false,
        isLoading: false,
        onlineInstitute: false,
        instituteError:'',
        footerLogo: null
    }),
    created() {
        this.loadInstituteDetails();
        if (
            `${window.location.protocol}//${window.location.host}` ===
            "https://mseducation.dev.eduracle.com"
        ) {
            this.dialog = true;
        }
        sessionStorage.removeItem('excludeRoute')
    },
    mounted() {
        this.onlineInstitute = (this.myInstitute && this.myInstitute.id == constants.ONLINE_INSTITUTE_ID) ? true : false;
        this.footerLogo = this.getFooterLogo();
        this.$refs.userId.focus();
            this.isLoading = true

        // Check URL query params first (from rewise.site redirect), then fall back to cookies.
        // Cookie reads go through readCookieJSON — a corrupt/legacy cookie value must
        // not throw and kill the whole auto-login flow.
        let urlToken = this.$route.query.token;
        let token = urlToken || this.readCookieJSON('userToken');
        let isValidUser = !!urlToken || this.readCookieJSON('redirectFromWebsite');
        let loggedInUsers = this.readCookieJSON('isLoggedIn');
        // An explicit keepMeLoggedIn in the URL (website handoff) must win over any
        // stale cookie from a previous session — the old `query || cookie` let a stale
        // keepMeLoggedIn=true cookie override an explicit keepMeLoggedIn=false.
        this.keepMeLoggedIn = this.$route.query.keepMeLoggedIn != null
            ? this.$route.query.keepMeLoggedIn === 'true'
            : this.readCookieJSON('keepMeLoggedIn');

        // Clean token from URL to avoid exposing it in browser history
        if (urlToken) {
            window.history.replaceState({}, document.title, this.$route.path);
            // Fresh handoff: drop any leftover local session NOW. A stale auth_token
            // here made the push(home) fast-path below navigate with an expired token,
            // whose 401 then wiped the fresh session mid-login and stranded the
            // student on the password form.
            sessionStorage.removeItem('auth_token');
            sessionStorage.removeItem('user');
            localStorage.removeItem('auth_token');
            localStorage.removeItem('user');
        }

        this.$cookies.remove('redirectFromWebsite',this.COOKIE_PATH,this.COOKIE_DOMAIN);
        if ((this.keepMeLoggedIn) && localStorage.getItem('auth_token')) {
            this.$router.push({name:"home"})

            // Never fall through to loginWebsite — the two navigations race.
            return;
        }
        if (isValidUser && token) {
            this.loginWebsite(token)
        }else if(loggedInUsers && token){
            this.loginWebsite(token)
        }
        else{
            this.isLoading = false
        }
    },
    watch: {
        userId(val) {
            this.error.email.type = null;
        },
        password(val) {
            this.error.password.type = null;
        },
    },
    computed: {
        ...mapState("userStore", ["isDefaultInstitute","myInstitute"]),
        // Hide signup for online institute and for Spectrum (462), which has no self-signup
        showSignup() {
            return !this.onlineInstitute &&
                !(this.myInstitute && Number(this.myInstitute.id) === constants.SPECTRUM_INSTITUTE_ID);
        },
    },
    methods: {
        ...mapMutations("userStore", ["updateIsDefaultInstitute"]),
        ...mapActions({
            logIn: "userStore/logIn",
            getInstituteDetails: "userStore/getInstituteDetails",
            setPendingTestList: "userStore/setPendingTestList",
        }),
        readCookieJSON(name) {
            // Cookies shared with the website (.rewise.site) may hold legacy or
            // corrupt values; JSON.parse throwing here would abort mounted() and
            // silently skip the token auto-login.
            try {
                return JSON.parse(this.$cookies.get(name));
            } catch (e) {
                return null;
            }
        },
        onForgotPassword() {
            this.$router.push({ name: "forgot-password" });
        },
        signUp() {
            this.$router.push({ name: "signup" });
        },
        loadInstituteDetails() {
            this.getInstituteDetails()
                .then((response) => {
                    // this.logo = response.logo_url > "" ? response.logo_url : this.logo;
                    this.logo = this.getInstituteLogo();
                    let isDefaultInstitute = this.checkIsDefaultInstitute();
                    this.updateIsDefaultInstitute(isDefaultInstitute);
                    this.setPageTitle(isDefaultInstitute);
                    if (this.CUSTOM_INSTITUTE_ID.includes(response.id)) {
                        this.$router.push({ name: "customized-tests-myt" });
                        
                    }
                })
                .catch((e) => {
                    e.data.errors.map(err=>{
                        this.instituteError = err.message
                    })
                    if (this.logo == null) {
                        this.logo = this.isOnlineInstitute()
                            ? require("@/assets/img/rewise-logo-powered.png")
                            : require("@/assets/img/Login_Page_logo.png");
                    }
                });
        },
        submit(event) {
            event.preventDefault();
            this.$root.showLoader = true;

            if (this.validate()) {
                this.logIn({
                    username: this.userId.trim(),
                    password: this.password,
                    external: true
                })
                    .then((response) => {
                        if(response){
                            sessionStorage.setItem(
                                "onPopUpFeedBackModal",
                                true
                            );
                        }
                        // window.hj('identify',response.id,response)
                        if (response.username) {
                            // Redirect students/parents to v2 app (skip for Rewise/online institute)
                            if ([constants.ROLES_ID.ST, constants.ROLES_ID.PA].includes(response.role_id) && response.institute !== this.ONLINE_INSTITUTE_ID) {
                                window.location.href = window.location.origin + '/v2/';
                                return;
                            }
                            this.setPendingTestList(null);
                            let redirectPath = "home";
                            let redirectAfterLogin = sessionStorage.getItem(
                                "redirectAfterLogin"
                            );
                            let excludeRoute = ['practice-session-question-view','topic-health', 'chapters-health', 'test']
                            const user = JSON.parse(
                                sessionStorage.getItem("oldRoleId")
                            );

                            if (redirectAfterLogin && user === response.role_id && !excludeRoute.includes(redirectAfterLogin)){
                                redirectPath = redirectAfterLogin;
                            }
                            sessionStorage.removeItem("redirectAfterLogin");
                            this.$router.push({ name: redirectPath });
                        } else {
                            this.$router.push({ name: "change-password" });
                        }
                        this.$root.showLoader = false;
                        // this.$cookies.remove('userDetails');
                    })
                    .catch((e) => {
                        this.$root.showLoader = false;
                    });
            } else {
                this.$root.showLoader = false;
            }
        },
        validate() {
            let isValid = true;

            this.error.email.type = null;
            this.error.password.type = null;
            if (!this.userId || this.userId.trim().length < 1) {
                this.error.email.type = "error";
                this.error.email.message = "Please enter email/username";
                isValid = false;
            }
            // else if (!this.isValidEmail(this.userId.trim())) {
            //     this.error.email.type = "error";
            //     this.error.email.message =
            //     "Please enter a valid email ID";
            //     isValid = false;
            // }

            if (!this.password || this.password.trim().length < 1) {
                this.error.password.type = "error";
                this.error.password.message = "Please enter password";
                isValid = false;
            }
            return isValid;
        },
        loginWebsite(token){
            let reqData = {
                token:  token,
                external:true,
                keepMeLoggedIn:this.keepMeLoggedIn

            }
            this.$root.showLoader = true;
            this.isLoading = true
            this.logIn(reqData)
            .then(response=>{
                if(response){
                    sessionStorage.setItem(
                        "onPopUpFeedBackModal",
                        true
                    );
                }
                let product = this.$cookies.get('upgrade');

                // Redirect students/parents to v2 app (skip for Rewise/online institute)
                if ([constants.ROLES_ID.ST, constants.ROLES_ID.PA].includes(response.role_id) && response.institute !== this.ONLINE_INSTITUTE_ID) {
                    window.location.href = window.location.origin + '/v2/';
                    return;
                }
                if (response.institute ===this.ONLINE_INSTITUTE_ID ) {

                    if (product) {
                        this.$router.push({name:"my-subscription",query:{productId:product}})
                    }else{
                        this.$root.showLoader = false;
                        this.$router.push({name:"home"}).catch(function(){
                            window.location.href = '/dashboard/home';
                        })
                        return;
                    }
                }
                this.$root.showLoader = false;
                this.isLoading = false
            })
            .catch(err=>{
                // The token was rejected (expired/invalid). Clear the shared
                // website cookies so every future page load doesn't retry the
                // same dead token forever. Only on a structured auth rejection —
                // a network failure (no response body) must not log the user
                // out of the website session.
                if (err && err.data && err.data.errors && err.data.errors.length) {
                    // Remove both domain- and host-scoped variants (setters vary).
                    ['userToken', 'isLoggedIn'].forEach(name => {
                        this.$cookies.remove(name, this.COOKIE_PATH, this.COOKIE_DOMAIN);
                        this.$cookies.remove(name, this.COOKIE_PATH);
                    });
                }
                this.$root.showLoader = false;
                this.isLoading = false

            })
        }
    },
};
</script>
